module.exports = __webpack_public_path__ + "static/media/gift-flat.21ed5f9b.png";